import { render, staticRenderFns } from "./RiskScoreTag.vue?vue&type=template&id=74c125fe&scoped=true"
import script from "./RiskScoreTag.vue?vue&type=script&lang=js"
export * from "./RiskScoreTag.vue?vue&type=script&lang=js"
import style0 from "./RiskScoreTag.vue?vue&type=style&index=0&id=74c125fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c125fe",
  null
  
)

export default component.exports